import { useState, useEffect, type RefObject } from 'react';

/**
 * Tracks the content width of a container element via ResizeObserver.
 * Returns undefined until the first measurement fires.
 */
export function useContainerWidth(
  ref: RefObject<HTMLElement | null>
): number | undefined {
  const [width, setWidth] = useState<number | undefined>(undefined);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (entry) {
        setWidth(entry.contentRect.width);
      }
    });

    observer.observe(el);
    return () => observer.disconnect();
  }, [ref]);

  return width;
}
